import * as Sentry from '@sentry/svelte';
import { BrowserTracing } from '@sentry/tracing';
import { CaptureConsole } from '@sentry/integrations';
import { getItem, setItem } from './storage';
import { v4 as uuidv4 } from 'uuid';
import { isFlagSetInLocalStorage } from './config.js';

export const initSentry = () => {
  const configuration = {
    SENTRY_DSN:
      'https://83cfbb72a17d45bfa8caf41c96813ddc@o124059.ingest.sentry.io/4504774069518336',
    DEBUG_SENTRY: isFlagSetInLocalStorage('pin-nuts-debug-sentry'),
    FULL_VERSION: import.meta.env.VITE_FULL_VERSION,
  };

  if (import.meta.env.PROD) {
    const environment = import.meta.env.VITE_URL_PATH.includes('/pin/')
      ? 'nonprod'
      : 'production';
    Sentry.init({
      debug: configuration.DEBUG_SENTRY,
      dsn: configuration.SENTRY_DSN,
      integrations: [
        new BrowserTracing(),
        new CaptureConsole({ levels: ['error'] }),
      ],
      autoSessionTracking: true,
      normalizeMaxBreadth: 10,
      normalizeDepth: 3,
      sampleRate: 0.2,
      tracesSampleRate: 0.05,
      release: configuration.FULL_VERSION,
      environment,
    });

    Sentry.setUser({
      id: getSessionUUID(),
    });
  } else {
    console.log('Not sending to Sentry - SENTRY_DSN is not set');
  }
};

export const getSessionUUID = function () {
  const uuid = getItem<string>('session', 'userid');
  if (uuid) {
    return uuid;
  }
  const newUUID = uuidv4();
  setItem('session', 'userid', newUUID);
  return newUUID;
};
